<template>
  <div class="article-mod">
    <div class="title">{{art.title}}</div>
   <div class="title-sub">{{art.sub_title}}</div>
    <div class="info">
      本信息由{{art.author}}于
      <span>{{(art.publish_time||'').substring(0,16)}}</span> 发布 共
      <span>{{art.view_num}}</span>次访问
    </div>
    <div class="content" v-html="art.context">

    </div>

    <el-row :gutter="20" class="am-margin-top-sm button-bar">
      <el-col :span="12">
           <el-button  v-if="prevArt"  style="max-width:100%" @click="to(prevArt.article_id)">
            <div class="am-text-right am-text-truncate">
                上一篇：{{prevArt.title}}</div>
            </el-button>
            <template v-else> &nbsp;</template>
      </el-col>
      <el-col :span="12" class="am-text-right">
        <el-button v-if="nextArt" style="max-width:100%" @click="to(nextArt.article_id)" >
          <div class="am-text-right am-text-truncate">
            下一篇：{{nextArt.title}}</div>
        </el-button>
      </el-col>
    </el-row>

  </div>
</template>

<script>
  export default {
    props: {
      nextArt: {
        default: ''
      },
      prevArt: {
        default: ''
      },
      art: {
        default: {}
      }
    },
    methods:{
      to(articleId){
        this.$router.push('/article/'+articleId)
      }
    },
  }

</script>

<style lang="scss">
  .article-mod {
    background-color: white;
    border-radius: 20px;
    background-repeat: no-repeat;
    background-position: 20px 20px;
    padding: 80px 30px;
    font-family: Arial, 'Microsoft Yahei', sans-serif;
    .title {
      font-size: 28px;
      font-weight: bold;
      margin-bottom: 20px;
      text-align: center;
    }
    .title-sub {
      font-size: 18px;
      margin-bottom: 12px;
      color: rgb(95, 95, 95);
      text-align: center;

    }
    .info {
      border-left: 4px solid #ddd;
      margin: 20px 0;
      font-size: 16px;
      padding-left: 12px;
      color: gray;
      font-family: Georgia, "Times New Roman", Times, Kai, "Kaiti SC", KaiTi, BiauKai, "FontAwesome", serif;
      span {
        color: #057bdf;
      }
    }
    .content {
      img {
        max-width: 100%;
      }
    }
    .button-bar{
      z-index: 999;
      position: relative;
    }
  }

</style>
